/**
 * permette di controllare il numero di volte che una data funzione viene chiamata
 * e impedire che venga chiamata oltre quel numero
 */
export class TimeInvoking {
  protected register: { [id: string]: number } = {};

  constructor() {}

  invokeOnce(id: string, fn: () => any): void {
    this.invoke(id, fn, { times: 1 });
  }

  invoke(id: string, fn: () => any, options: { times?: number } = {}): void {
    if (
      options &&
      typeof options.times === 'number' &&
      this.howManyTimes(id) >= options.times
    ) {
      return;
    }

    fn();

    this.countTime(id);
  }

  protected howManyTimes(id: string): number {
    if (!!id && typeof this.register[id] === 'number') {
      return this.register[id];
    } else {
      return 0;
    }
  }

  private countTime(id: string): void {
    if (!id) {
      return;
    }

    if (typeof this.register[id] !== 'number') {
      this.register[id] = 1;
    } else {
      this.register[id]++;
    }
  }
}
